import { Select } from 'antd';
import { useState, useCallback, useEffect, useMemo } from 'react';
import { API } from '../api';
import { notifyError } from '../store/utils';

interface DistrictSelectProps {
  value?: string;
  showSearch?: boolean;
  allowClear?: boolean;
  disabled?: boolean;
  district?: any;
  provinceNo?: any;
  onChange?: (value: string) => void;
}

const DistrictSelect: React.FC<DistrictSelectProps> = ({
  value,
  showSearch,
  allowClear,
  disabled,
  district,
  provinceNo,
  onChange,
}) => {
  const [state, updateState] = useState<any[]>([]);

  const onSearch = useCallback(async (query: string) => {
    try {
      const { result } = await API.get({ apiVersion: 'api' })(`/address/district/list`);
      updateState(result?.data || []);
    } catch (error: any) {
      notifyError(error.message);
    }
  }, []);

  const loadFirst = useCallback(async () => {
    try {
      const { result } = await API.get({ apiVersion: 'api' })(
        `/address/districts/${provinceNo}?page=1&size=10`
      );
      const list = result?.data || [];
      const check = list.filter((it: any) => it.no === district?.no);
      if (district && check.length) {
        updateState([...list, district]);
      } else {
        updateState(list);
      }
    } catch (error: any) {
      notifyError(error.message);
    }
  }, [district, provinceNo]);

  useEffect(() => {
    if (provinceNo) {
      loadFirst();
    }
  }, [provinceNo]);

  const options = useMemo(() => {
    return state.map((item: any) => {
      return {
        label: item.name,
        value: item.no,
      };
    });
  }, [state]);

  return (
    <Select
      placeholder="Сум дүүрэг сонгоно уу"
      showSearch={showSearch}
      allowClear={allowClear}
      //onSearch={(query: string) => onSearch(query)}
      onChange={onChange}
      options={options}
      value={value}
      disabled={!provinceNo || disabled}
      optionFilterProp="label"
      //filterOption={false}
    />
  );
};

export default DistrictSelect;
